function stripDiacritics(value) {
  return String(value || '')
    .normalize('NFD')
    .replace(/[\u0300-\u036f]/g, '');
}

export function normalizePrintGroup(value) {
  return stripDiacritics(value)
    .trim()
    .toLowerCase()
    .replace(/\s+/g, '');
}

export function canonicalPrintGroupLabel(value) {
  const normalized = normalizePrintGroup(value);

  if (normalized === 'kuche' || normalized === 'kueche') {
    return 'Küche';
  }

  if (normalized === 'bar') {
    return 'Bar';
  }

  return String(value || '').trim();
}

export function printGroupsEqual(left, right) {
  return normalizePrintGroup(left) === normalizePrintGroup(right);
}

export function includesPrintGroup(groups, value) {
  return (groups || []).some((group) => printGroupsEqual(group, value));
}

export function harmonizePrintGroup(value, preferredGroups = []) {
  const preferredMatch = (preferredGroups || []).find((group) => printGroupsEqual(group, value));
  if (preferredMatch) {
    return canonicalPrintGroupLabel(preferredMatch);
  }

  return canonicalPrintGroupLabel(value);
}
